.datePicker {
  position: relative;
  width: 100%;
}

.datePickerButton {
  width: 100%;
}

.buttonContent {
  width: 100%;
}

.invalid {
  border: 1px solid var(--sentiment-text-negative) !important;
}

.datePickerButton:focus {
  border-color: var(--primary-enabled);
  outline: none;
}

.calendarContainer {
  min-height: fit-content;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);
  background: var(--static-background-weak);
  box-shadow: var(--box-shadow);
  width: min-content;
}

.calendar :global(.react-calendar__navigation) {
  display: flex;
  justify-content: space-evenly;
  gap: 0.5rem;
  margin-bottom: 10px;
}
.calendar :global(.react-calendar__navigation__prev-button),
.calendar :global(.react-calendar__navigation__prev2-button),
.calendar :global(.react-calendar__navigation__next-button),
.calendar :global(.react-calendar__navigation__next2-button) {
  all: unset;
  font: inherit;
  color: var(--static-text-strong);
  font-weight: 500;
  margin: 0 1rem;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calendar :global(.react-calendar__navigation__prev-button:hover),
.calendar :global(.react-calendar__navigation__prev2-button:hover),
.calendar :global(.react-calendar__navigation__next-button:hover),
.calendar :global(.react-calendar__navigation__next2-button:hover) {
  background: var(--secondary-hover);
  cursor: pointer;
}

.calendar :global(.react-calendar__tile) {
  all: unset;
  text-align: center;
  color: var(--static-text-standard);

  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar :global(.react-calendar__tile abbr):hover {
  background: var(--secondary-hover);
  cursor: pointer;
  color: var(--primary-hover);
}

.calendar :global(.react-calendar__tile abbr) {
  aspect-ratio: 1/1;
}

.calendar :global(.react-calendar__tile abbr) {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}

.calendar :global(.react-calendar__month-view__weekdays__weekday) {
  text-align: center;
}
.calendar :global(.react-calendar__month-view__weekdays__weekday) abbr {
  text-decoration: none;
  color: var(--static-text-weak);
}

.calendar :global(.react-calendar__navigation__label) {
  all: unset;
  font: inherit;
  text-align: center;
  color: var(--static-text-strong);
  font-weight: 500;
}

.calendar :global(.react-calendar__tile--hover) {
  background: var(--selectable-hover);
}

.calendar :global(.react-calendar__tile) {
  font: inherit;
  font-weight: normal;
}
.calendar :global(.react-calendar__tile--now abbr) {
  color: var(--primary-enabled);
  border: 1px solid;
  border-color: var(--primary-enabled);
  font-weight: 500;
}

.calendar :global(.react-calendar__tile--now:enabled:hover abbr),
.calendar :global(.react-calendar__tile--now:enabled:focus abbr) {
  background-color: var(--secondary-hover);
}

.calendar :global(.react-calendar__tile--hasActive abbr) {
  background: var(--primary-enabled);
  border-color: var(--primary-enabled);
  font-weight: 500;
}

.calendar :global(.react-calendar__tile--hasActive:enabled:hover abbr),
.calendar :global(.react-calendar__tile--hasActive:enabled:focus abbr) {
  color: var(--primary-enabled-text);
  background: var(--primary-hover);
  border-color: var(--primary-enabled);
}

.calendar :global(.react-calendar__tile--active abbr) {
  color: var(--primary-enabled-text);
  background: var(--primary-hover);
  border-color: var(--primary-enabled);
}

/*
   this prevents the width of the dropdown from changing based on the length of
   the name of the month (i.e., "May" vs. "September"
 */
:global(.react-calendar__navigation__label__labelText) {
  width: 90px;
  display: inline-block;
}
